import { StoryPageDisplay } from '../enums';
import { Renderer, RendererWithTester, SanitizedStoryPage } from '../types';

interface Params {
    renderers: RendererWithTester[];
    storyPageDisplay: StoryPageDisplay;
    storyPage: SanitizedStoryPage;
}

export const getRenderer = ({
    renderers,
    storyPageDisplay,
    storyPage,
}: Params): Renderer => {
    const probable = renderers
        .map((r) => {
            return {
                ...r,
                testerResult: r.tester(storyPageDisplay, storyPage),
            };
        })
        .filter((r) => r.testerResult.condition);
    probable.sort((a, b) => b.testerResult.priority - a.testerResult.priority);
    return probable[0].renderer;
};
